import { RoutalPalette, RoutalTooltip } from '@nx-smartmonkey/ui';
import { cloneElement, useState } from 'react';
import SideBarMenuItem from './SideBarMenuItem';
import SideBarMenuItemContainer from './SideBarMenuItemContainer';

export interface SideBarMenuItemProps {
  id: string;
  label: React.ReactElement | string;
  icon: React.ReactElement;
  onClick: () => any;
  isNew?: boolean;
  selected?: boolean;
}

export const SideBarSectionsMenuItem = ({
  id,
  label,
  icon,
  onClick,
  isNew,
  selected = false,
}: SideBarMenuItemProps) => {
  const [isHover, setHover] = useState<boolean>(false);

  return (
    <RoutalTooltip id={id} title={label} placement="right">
      <SideBarMenuItemContainer
        onClick={onClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        selected={selected}
      >
        <SideBarMenuItem>
          {cloneElement(icon, {
            isHover: isHover,
          })}
          {isNew ? (
            <span
              style={{
                position: `absolute`,
                borderRadius: `2px`,
                backgroundColor: RoutalPalette.primary40,
                fontSize: `8px`,
                fontWeight: `bold`,
                zIndex: 1,
                color: RoutalPalette.neutral00,
                marginLeft: `33px`,
                marginBottom: `41px`,
                padding: `1px 3px`,
              }}
            >
              new
            </span>
          ) : null}
        </SideBarMenuItem>
      </SideBarMenuItemContainer>
    </RoutalTooltip>
  );
};
